import { Link } from "react-router-dom";
import { CONTACT, LOGO_URL } from "../lib/site";
import { useT } from "../context/LangContext";

export const Footer = () => {
  const { t } = useT();
  return (
    <footer className="bg-ink text-bone" data-testid="footer">
      <div className="mx-auto max-w-7xl px-5 md:px-8 py-12 md:py-16">
        <div className="grid gap-12 md:grid-cols-12">
          <div className="md:col-span-5">
            <img src={LOGO_URL} alt="Common Ground Project" className="h-16 w-auto mb-6 bg-white rounded-xl p-2.5" />
            <p className="font-serif italic text-2xl md:text-3xl leading-snug text-bone/90 max-w-md">
              {t.footer.tagline}
            </p>
          </div>
          <div className="md:col-span-3 md:col-start-7">
            <h4 className="font-display font-bold tracking-widest text-xs text-ochre mb-5">{t.footer.navTitle}</h4>
            <ul className="space-y-3">
              {t.nav.map((n) => (
                <li key={n.to}>
                  <Link to={n.to} className="text-bone/70 hover:text-white transition-colors duration-200">
                    {n.label}
                  </Link>
                </li>
              ))}
              <li>
                <Link to="/sostienici" className="text-terracotta hover:text-white transition-colors duration-200 font-semibold">
                  {t.donate}
                </Link>
              </li>
            </ul>
          </div>
          <div className="md:col-span-3">
            <h4 className="font-display font-bold tracking-widest text-xs text-ochre mb-5">{t.footer.contactTitle}</h4>
            <ul className="space-y-3 text-bone/70">
              <li><a href={`mailto:${CONTACT.email}`} className="hover:text-white transition-colors duration-200">{CONTACT.email}</a></li>
              <li>{CONTACT.phone}</li>
            </ul>
          </div>
        </div>
        <div className="mt-10 pt-6 border-t border-white/10 flex flex-col md:flex-row justify-between gap-4 text-sm text-bone/50">
          <span>© {new Date().getFullYear()} {CONTACT.org}</span>
          <div className="flex gap-6">
            <Link to="/privacy" data-testid="footer-privacy-link" className="hover:text-white transition-colors duration-200">{t.footer.privacyLink}</Link>
            <span>{t.footer.ets}</span>
          </div>
        </div>
      </div>
    </footer>
  );
};
